import { TableModalState } from './types';

export const AUTOSIZE_DELAY_MS = 100;
export const COLUMN_RESIZE_DEBOUNCE_MS = 300;
export const FILTER_DEBOUNCE_MS = 200;
export const CHECKBOX_COL_WIDTH = 56;
export const PAGE_SIZE_OPTIONS = [25, 50, 100, 250, 500] as const;
export const DEFAULT_PRESET_NAME = 'Custom';
export const NO_MODAL_ID = -1;

export const INITIAL_MODAL_STATE: TableModalState = {
  id: NO_MODAL_ID,
  action: 'create',
};
